<mat-card class="filter settingHeader">
  <div class="name">
    Manage Dashboard  Stages
  </div>

  <div class="quickAction">    
      <!-- <mat-form-field class="example-form-field" appearence="fill">
        <mat-label>Search process stage</mat-label>
        <input matInput type="text"  readonly  [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
        <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>close</mat-icon>
        </button>
        <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field> -->
        
        <div class="">      
          <button mat-flat-button color="primary" (click)="openDialogAdd(addmyDialog,1)"> Add Process Stage </button>   
          <!-- <button mat-flat-button color="primary" (click)="openDialogForAddCategory()"> Add Category </button> -->
       </div>
     
  </div>
</mat-card>

<div class="documents">

    <mat-card class="example-list rowholder card-gap">
      <div class="fieldRow head">
        <span class="moveicon"></span>       
        <span class="fieldName">Stage Name(System)</span>
        <span class="fieldName">Stage Name(Office)</span>
        <span class="fieldName">Category</span>
        <span class="requried">Default</span>
        <span class="requried">Show On Dashboard</span>
        <span class="requried">Active/Inactive</span>
        <span class="editField">Edit</span>
        <span class="delete">Delete</span>
      </div>
       <div cdkDropList (cdkDropListDropped)="drop($event)">
        <div  class="example-box fieldRow" *ngFor="let type of ProcessStageList" cdkDrag>
          <span class="moveicon"></span> 
           <div class="DragIcon" cdkDragHandle>
        <mat-icon>drag_handle</mat-icon>
      </div>       
          <span class="fieldName">{{type.systemProcessStageName}}</span> 
          <span class="fieldName">{{type.processStageName}}</span>  
           <span class="fieldName">{{type.categoryName}}</span>
          <span class="requried">
            <mat-checkbox color="primary" (change)="SetDefaultProcessStage($event,type)" [checked]= "type.isDefualt">
            </mat-checkbox>
          </span> 
          <span class="requried">
            <mat-checkbox color="primary" (change)="UpdateShowOnDashboard($event,type)" [checked]= "type.showOnDashboard">
            </mat-checkbox>
          </span> 
          <span class="requried">
            <mat-slide-toggle color="primary"  [checked]="type.isActive" (change)="UpdateStatus($event,type)">
            </mat-slide-toggle>
          </span> 
    
          <span class="editField">
            <button mat-icon-button class="editbtn" (click)="openDialogUpdateType(myDialog,type)">
              <mat-icon>edit</mat-icon>
            </button>
          </span>
    
          <span class="delete">
            <button mat-icon-button class="trash"  (click)="DeleteCategory(type)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </span>
        </div>     
       </div>
    </mat-card>
    <mat-card class="filter settingHeader">
       <div class="name card-gap">
      Manage PDPM  Stages
     </div>   
  <div class="quickAction">    
      <!-- <mat-form-field class="example-form-field" appearence="fill">
        <mat-label>Search process stage</mat-label>
        <input matInput type="text"  readonly  [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
        <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>close</mat-icon>
        </button>
        <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field> -->
        
        <div class="">      
          <button mat-flat-button color="primary" (click)="openDialogAdd(addmyDialog,2)"> Add PDPM Stage </button>   
          <!-- <button mat-flat-button color="primary" (click)="openDialogForAddCategory()"> Add Category </button> -->
       </div>
     
  </div>


     </mat-card>

  


   <mat-card class="example-list rowholder card-gap">
          <div class="fieldRow head">
        <span class="moveicon"></span>       
        <span class="fieldName">Stage Name(System)</span>
        <span class="fieldName">Stage Name(Office)</span>
        <span class="fieldName">Category</span>
        <span class="requried">Default</span>
        <span class="requried">Show On Dashboard</span>
        <span class="requried">Active/Inactive</span>
        <span class="editField">Edit</span>
        <span class="delete">Delete</span>
      </div>
       <div cdkDropList (cdkDropListDropped)="drop($event)">
        <div  class="example-box fieldRow" *ngFor="let type of MedicalStageList" cdkDrag>
          <span class="moveicon"></span> 
           <div class="DragIcon" cdkDragHandle>
        <mat-icon>drag_handle</mat-icon>
      </div>       
          <span class="fieldName">{{type.systemProcessStageName}}</span> 
          <span class="fieldName">{{type.processStageName}}</span>  
           <span class="fieldName">{{type.categoryName}}</span>
          <span class="requried">
            <mat-checkbox color="primary" (change)="SetDefaultProcessStage($event,type)" [checked]= "type.isDefualt">
            </mat-checkbox>
          </span> 
          <span class="requried">
            <mat-checkbox color="primary" (change)="UpdateShowOnDashboard($event,type)" [checked]= "type.showOnDashboard">
            </mat-checkbox>
          </span> 
          <span class="requried">
            <mat-slide-toggle color="primary"  [checked]="type.isActive" (change)="UpdateStatus($event,type)">
            </mat-slide-toggle>
          </span> 
    
          <span class="editField">
            <button mat-icon-button class="editbtn" (click)="openDialogUpdateType(myDialog,type)">
              <mat-icon>edit</mat-icon>
            </button>
          </span>
    
          <span class="delete">
            <button mat-icon-button class="trash"  (click)="DeleteCategory(type)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </span>
        </div>     
       </div>
    </mat-card>

</div>


<ng-template #addmyDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Add {{title}} Stage Name
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>{{title}} Stage Name</mat-label>
      <input matInput maxlength="30" [required]="true"  placeholder="add {{title}} stage name"  formControlName="processStageName"/>
      <mat-error
      *ngIf="formDialog.get('processStageName').invalid &&
        (formDialog.get('processStageName').dirty ||
        formDialog.get('processStageName').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" 
  [disabled]="formDialog.invalid || !formDialog.dirty"   
  (click)="AddCategoryNameDetails(formDialog.value , categoryIdForDialog)">
    Save
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>

<ng-template #myDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Edit {{title}} Stage Name
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>{{title}} Stage Name</mat-label>
      <input matInput maxlength="30" [required]="true"  placeholder="add {{title}} stage name"  formControlName="processStageName"/>
      <mat-error
      *ngIf="formDialog.get('processStageName').invalid &&
        (formDialog.get('processStageName').dirty ||
        formDialog.get('processStageName').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" 
  [disabled]="formDialog.invalid || !formDialog.dirty"   
  (click)="UpdateCategoryNameDetails(formDialog.value)">
    Update
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>

